import { jsx } from 'react/jsx-runtime';
import { StyledBaseIconButton, StyledIconCloseCircle } from './styles.js';

const IconButtonClose = ({
  'data-test': testId,
  onClick,
  iconSize
}) => jsx(StyledBaseIconButton, {
  "aria-label": "close",
  "data-test": testId,
  onClick: onClick,
  renderIcon: jsx(StyledIconCloseCircle, {
    size: iconSize === 'sm' ? '32px' : '44px'
  }, void 0)
}, void 0);

IconButtonClose.displayName = 'IconButtonClose';

export { IconButtonClose };
